const EmergencyRFV = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
		<path
			d="M14.6191 -0.000976562C15.2708 -0.000976562 15.8029 0.526189 15.8066 1.17578V6.21191H20.8203C21.4718 6.21937 21.9998 6.74532 22 7.39844V14.6416C21.9999 14.9551 21.8799 15.2573 21.6553 15.4775C21.4343 15.7014 21.1348 15.8252 20.8203 15.8252H15.8066V20.8232C15.8029 21.4541 15.3047 21.97 14.6758 22H7.40723C6.75562 22 6.22347 21.4766 6.21973 20.8232V15.8252H1.17578C0.857485 15.8289 0.549884 15.6983 0.325195 15.4668C0.131821 15.2642 0.0158678 15.0013 0 14.7236V7.35742C0.000241161 6.70802 0.52434 6.17854 1.17578 6.1748H6.21973V1.17578C6.22347 0.537362 6.73676 0.0139565 7.38086 -0.000976562H14.6191Z"
			fill="#CA4A59"
		/>
	</svg>
);

export default EmergencyRFV;
